import { computed } from 'vue';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasNoElementarGefahren,
  hasNoPreviousDamage,
} from '@/features/Sparten/shared/contractDehydration/property/conditionalRequestDefinitions';
import {
  hasDoctorsOffice,
  hasGebaeudeImBau,
  hasOffice,
  hasOtherBusinesses,
  isCommercialUse,
  hasElementarDamage,
  hasGlasDamage,
} from '@/features/Sparten/woh/formConfigs/sharedRenderConditions';

export const hasNoGewerblicheNutzung: ConditionalRequestDefinition = {
  if: computed(() => !isCommercialUse.value),
  drop: ['gewerbeGebaeude'],
};

export const hasNoDoctorsOffice: ConditionalRequestDefinition = {
  if: computed(() => !hasDoctorsOffice.value),
  drop: ['gewerbeGebaeude.flaechePraxen'],
};

export const hasNoOffice: ConditionalRequestDefinition = {
  if: computed(() => !hasOffice.value),
  drop: ['gewerbeGebaeude.flaecheBueros'],
};

export const hasNoOtherBusinesses: ConditionalRequestDefinition = {
  if: computed(() => !hasOtherBusinesses.value),
  drop: ['gewerbeGebaeude.flaecheSonstigeGewerbe'],
};

export const hasNoRohbau: ConditionalRequestDefinition = {
  if: computed(() => !hasGebaeudeImBau.value),
  drop: ['rohbau'],
};

export const hasNoElementarDamageConditional: ConditionalRequestDefinition = {
  if: computed(() => !hasElementarDamage.value),
  drop: ['vorschaden.elementarAnzahl', 'vorschaden.elementarEntschaedigung'],
};

export const hasNoGlasDamageConditional: ConditionalRequestDefinition = {
  if: computed(() => !hasGlasDamage.value),
  drop: ['vorschaden.glasAnzahl', 'vorschaden.glasEntschaedigung'],
};

export const wohContractDehydrationDefinitions: ConditionalRequestDefinition[] =
  [
    hasNoElementarGefahren,
    hasNoGewerblicheNutzung,
    hasNoDoctorsOffice,
    hasNoOffice,
    hasNoOtherBusinesses,
    hasNoRohbau,
    hasNoElementarDamageConditional,
    hasNoGlasDamageConditional,
    hasNoPreviousDamage,
  ];
